/* ArtJo interface: alles wat niet met de winkelwagen zelf te maken heeft.
 * De winkelwagen zit in aj-cart.js. Die twee raken elkaar op een plek: de
 * bundel roept AJ.voegToe aan.
 *
 * Wat hierin zit:
 *   1. Bundel-motor      variant kiezen, live totaal, knop aan of uit
 *   2. Rastersorteren    client-side, want de grootste collectie heeft 31 kaarten
 *   3. Tabs              bestsellers en FAQ-groepen, met echte toetsenbordsteun
 *   4. Variant-store     een bron van waarheid per pagina, zodat koopblok,
 *                        koopbalk en galerij elkaar niet tegenspreken
 *   5. Mobiele koopbalk  schuift in zodra de hoofdknop uit beeld is
 *
 * Alle localStorage- en sessionStorage-toegang staat in try/catch. Een browser
 * in privemodus gooit daar, en dan zou de hele pagina eronder liggen.
 */
(function () {
  'use strict';

  var AJ = window.AJ || {};

  /* ------------------------------------------------------------------ */
  /* Hulp                                                                */
  /* ------------------------------------------------------------------ */

  function geld(centen) {
    /* Shopify's money-filter draait server-side. Client-side houden we het
       simpel en Nederlands: punt als duizendtal is hier niet nodig, de duurste
       bundel is 41,90. */
    var euro = (centen / 100).toFixed(2).replace('.', ',');
    return '€ ' + euro;
  }

  function veiligLees(sleutel) {
    try { return window.sessionStorage.getItem(sleutel); } catch (e) { return null; }
  }
  function veiligSchrijf(sleutel, waarde) {
    try { window.sessionStorage.setItem(sleutel, waarde); } catch (e) { /* privemodus */ }
  }

  /* ------------------------------------------------------------------ */
  /* 1. Bundel-motor                                                     */
  /* ------------------------------------------------------------------ */

  function bundelRijen(bundel) {
    return Array.prototype.slice.call(bundel.querySelectorAll('[data-aj-rij]'));
  }

  function bundelStand(bundel) {
    var rijen = bundelRijen(bundel);
    var items = [];
    var totaal = 0;
    var compleet = true;

    rijen.forEach(function (rij) {
      var gekozen = rij.querySelector('input[type="radio"]:checked');
      var kiezer = rij.querySelector('.aj-bundel__kiezer');

      if (kiezer && !gekozen) {
        compleet = false;
        return;
      }

      var id, prijs;
      if (gekozen) {
        id = Number(gekozen.value);
        prijs = Number(gekozen.getAttribute('data-prijs'));
      } else {
        id = Number(rij.getAttribute('data-standaard-variant'));
        var el = rij.querySelector('[data-aj-rijprijs]');
        prijs = Number(rij.getAttribute('data-standaard-prijs') || 0);
        if (!prijs && el) {
          /* De prijs staat al opgemaakt in de DOM; we lezen hem terug in centen.
             Alleen nodig voor rijen zonder varianten, dus een keer per rij. */
          prijs = Math.round(parseFloat(el.textContent.replace(/[^0-9,.-]/g, '').replace(',', '.')) * 100) || 0;
          rij.setAttribute('data-standaard-prijs', prijs);
        }
      }
      totaal += prijs;
      items.push({ id: id, quantity: 1 });
    });

    return { items: items, totaal: totaal, compleet: compleet };
  }

  function bundelVerversen(bundel) {
    var stand = bundelStand(bundel);
    var totaalEl = bundel.querySelector('[data-aj-totaal]');
    var knop = bundel.querySelector('[data-aj-bundelknop]');
    var label = knop && knop.querySelector('[data-aj-knoplabel]');

    if (totaalEl && stand.compleet) totaalEl.textContent = geld(stand.totaal);

    if (knop) {
      knop.disabled = !stand.compleet;
      if (label && !knop.hasAttribute('aria-busy')) {
        label.textContent = stand.compleet
          ? (knop.getAttribute('data-aj-label') || label.getAttribute('data-vol') || 'Alles toevoegen')
          : 'Kies eerst een kleur';
      }
    }
  }

  function bundelStart(bundel) {
    /* Het volle label onthouden voordat we het overschrijven met
       "Kies eerst een kleur". */
    var knop = bundel.querySelector('[data-aj-bundelknop]');
    var label = knop && knop.querySelector('[data-aj-knoplabel]');
    if (label && !label.getAttribute('data-vol')) {
      var start = label.textContent.trim();
      label.setAttribute('data-vol', start === 'Kies eerst een kleur' ? 'Alles toevoegen' : start);
    }

    bundel.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"]')) bundelVerversen(bundel);
    });

    if (knop) {
      knop.addEventListener('click', function () {
        var stand = bundelStand(bundel);
        if (!stand.compleet || !stand.items.length) return;
        if (AJ.voegToe) AJ.voegToe(stand.items, knop);
      });
    }

    bundelVerversen(bundel);
  }

  /* ------------------------------------------------------------------ */
  /* 2. Rastersorteren                                                   */
  /* ------------------------------------------------------------------ */

  var SORTEER = {
    aanbevolen: null, /* de serverorde, we zetten hem terug */
    'prijs-op': function (a, b) { return num(a, 'prijs') - num(b, 'prijs'); },
    'prijs-af': function (a, b) { return num(b, 'prijs') - num(a, 'prijs'); },
    delen: function (a, b) { return num(b, 'delen') - num(a, 'delen'); },
    naam: function (a, b) {
      return (a.getAttribute('data-titel') || '').localeCompare(b.getAttribute('data-titel') || '', 'nl');
    }
  };

  function num(el, naam) { return Number(el.getAttribute('data-' + naam)) || 0; }

  function sorteerStart(kiezer) {
    var doelId = kiezer.getAttribute('data-aj-sorteer');
    var raster = document.getElementById(doelId);
    if (!raster) return;

    /* De oorspronkelijke volgorde bewaren, anders is "Aanbevolen" onbereikbaar
       zodra er een keer gesorteerd is. */
    var origineel = Array.prototype.slice.call(raster.children);

    kiezer.addEventListener('change', function () {
      var fn = SORTEER[kiezer.value];
      var rij = fn ? origineel.slice().sort(fn) : origineel;
      var frag = document.createDocumentFragment();
      rij.forEach(function (el) { frag.appendChild(el); });
      raster.appendChild(frag);
      veiligSchrijf('aj-sorteer-' + doelId, kiezer.value);
    });

    var onthouden = veiligLees('aj-sorteer-' + doelId);
    if (onthouden && SORTEER.hasOwnProperty(onthouden) && onthouden !== kiezer.value) {
      kiezer.value = onthouden;
      kiezer.dispatchEvent(new Event('change'));
    }
  }

  /* ------------------------------------------------------------------ */
  /* 3. Tabs                                                             */
  /* ------------------------------------------------------------------ */

  function tabsStart(strip) {
    var knoppen = Array.prototype.slice.call(strip.querySelectorAll('[role="tab"]'));
    if (!knoppen.length) return;

    function toon(knop) {
      knoppen.forEach(function (k) {
        var aan = k === knop;
        k.setAttribute('aria-selected', aan ? 'true' : 'false');
        k.tabIndex = aan ? 0 : -1;
        var paneel = document.getElementById(k.getAttribute('aria-controls'));
        /* hidden, niet display:none via een klasse: de tekst van alle panelen
           blijft in de DOM en dus crawlbaar, maar alleen het actieve paneel
           staat in de toetsenbordvolgorde. */
        if (paneel) paneel.hidden = !aan;
      });
    }

    strip.addEventListener('click', function (e) {
      var knop = e.target.closest('[role="tab"]');
      if (knop) toon(knop);
    });

    strip.addEventListener('keydown', function (e) {
      var i = knoppen.indexOf(document.activeElement);
      if (i < 0) return;
      var volgende = null;
      if (e.key === 'ArrowRight') volgende = knoppen[(i + 1) % knoppen.length];
      if (e.key === 'ArrowLeft') volgende = knoppen[(i - 1 + knoppen.length) % knoppen.length];
      if (e.key === 'Home') volgende = knoppen[0];
      if (e.key === 'End') volgende = knoppen[knoppen.length - 1];
      if (volgende) {
        e.preventDefault();
        volgende.focus();
        toon(volgende);
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* 4. Variant-store en de productpagina                                */
  /* ------------------------------------------------------------------ */

  /* Een pagina, een waarheid. Koopblok, galerij en mobiele koopbalk luisteren
     allemaal naar dit ene event in plaats van elkaar te bevragen. Dat is de
     reden dat de koopbalk een blok van aj-pdp-hoofd is en geen eigen sectie:
     twee secties die het eens moeten blijven over de gekozen variant is precies
     de bug die je pas op een telefoon ziet. */
  AJ.zetVariant = function (variant) {
    AJ.variant = variant;
    document.dispatchEvent(new CustomEvent('aj:variant', { detail: variant }));
  };

  function pdpStart(pdp) {
    var databron = pdp.querySelector('[data-aj-variantdata]');
    var varianten = [];
    if (databron) {
      try { varianten = JSON.parse(databron.textContent); } catch (e) { varianten = []; }
    }
    var form = pdp.querySelector('[data-aj-pdpform]');
    var idVeld = pdp.querySelector('[data-aj-varid]');
    var hoofdknop = pdp.querySelector('[data-aj-hoofdknop]');
    var balkknop = pdp.querySelector('[data-aj-balkknop]');
    var voorraad = pdp.querySelector('[data-aj-voorraad]');
    var opregel = pdp.querySelector('[data-aj-opregel]');
    var hoofdbeeld = pdp.querySelector('[data-aj-hoofdbeeld]');

    /* De koopknop onderscheppen gebeurt ALTIJD, ook bij een product zonder
       varianten. Dat stond hier eerder onderaan, NA de afslag hieronder, en die
       afslag treedt op zodra er geen variantdata in de pagina staat. Die data
       komt uit snippets/aj-varianten.liquid en die rendert alleen bij twee of
       meer varianten. Gevolg, gemeten op 13 september 2026: bij 46 van de 61
       producten deed "In winkelwagen" een gewone formulierverzending, herlaadde
       de pagina en belandde de klant op /cart in plaats van in de lade.
       Het formulier blijft een echt formulier, zodat de knop ook werkt als dit
       script niet laadt. De vlag voorkomt dat een tweede aanroep van pdpStart,
       bijvoorbeeld na een sectie-herrendering, dezelfde luisteraar nog eens
       toevoegt en het artikel dubbel in de wagen legt. */
    if (form && !form.hasAttribute('data-aj-gekoppeld')) {
      form.setAttribute('data-aj-gekoppeld', '1');
      form.addEventListener('submit', function (e) {
        if (!AJ.voegToe || !idVeld || !idVeld.value) return;
        e.preventDefault();
        AJ.voegToe([{ id: Number(idVeld.value), quantity: 1 }], hoofdknop);
      });
    }

    if (!varianten.length) return;

    function gekozenOpties() {
      var uit = [];
      pdp.querySelectorAll('[data-aj-optie]').forEach(function (r) {
        if (r.checked) uit[Number(r.getAttribute('data-aj-optie')) - 1] = r.value;
      });
      return uit;
    }

    function zoekVariant(opties) {
      for (var i = 0; i < varianten.length; i++) {
        var v = varianten[i];
        var raak = true;
        for (var j = 0; j < opties.length; j++) {
          if (opties[j] !== undefined && v.opties[j] !== opties[j]) { raak = false; break; }
        }
        if (raak) return v;
      }
      return null;
    }

    function teken(v) {
      if (!v) return;

      pdp.querySelectorAll('[data-aj-prijs]').forEach(function (el) { el.textContent = v.prijs_tekst; });

      var oud = pdp.querySelector('[data-aj-oudprijs]');
      if (oud) oud.hidden = !(v.oud && v.oud > v.prijs);

      pdp.querySelectorAll('[data-aj-optiewaarde]').forEach(function (el) {
        var nr = Number(el.getAttribute('data-aj-optiewaarde')) - 1;
        if (v.opties[nr]) el.textContent = v.opties[nr];
      });

      if (idVeld) idVeld.value = v.id;

      if (voorraad) {
        voorraad.setAttribute('data-op', v.beschikbaar ? '' : 'true');
        /* innerHTML, want de regel begint met een gekleurd stipje in een span.
           Met textContent verdween dat stipje bij de eerste kleurwissel en kwam
           het nooit meer terug. Het stipje is bij uitverkocht bewust weg: dan
           voert de tekst zelf de boodschap. */
        voorraad.innerHTML = v.beschikbaar
          ? '<span class="aj-pdp__stip" aria-hidden="true"></span>Op voorraad'
          : 'Deze kleur is tijdelijk op';
      }
      /* De regel "Kies een andere kleur" alleen tonen als er echt iets te
         kiezen valt. Bij een product met een enkele variant is dat een dood
         advies. */
      if (opregel) opregel.hidden = v.beschikbaar || varianten.length < 2;

      [hoofdknop, balkknop].forEach(function (knop) {
        if (!knop) return;
        /* Een hersteltimer van een eerdere toevoeging afbreken. Anders zet die
           straks "In winkelwagen" terug op een knop die nu terecht uit staat. */
        if (knop._ajTimer) { clearTimeout(knop._ajTimer); knop._ajTimer = null; }
        knop.disabled = !v.beschikbaar;
        var label = knop.querySelector('[data-aj-knoplabel]');
        if (label && !knop.hasAttribute('aria-busy')) {
          label.textContent = v.beschikbaar ? (knop.getAttribute('data-aj-vol') || 'In winkelwagen') : 'Tijdelijk uitverkocht';
        }
        if (knop.hasAttribute('data-aj-toevoegen')) {
          knop.setAttribute('data-aj-toevoegen', JSON.stringify([{ id: v.id, quantity: 1 }]));
        }
      });

      /* Alleen het hoofdbeeld wisselt mee. De vervolgbeelden blijven staan: dat
         zijn de toepassings- en detailfoto's die voor elke kleur gelden. */
      if (hoofdbeeld && v.beeld) {
        hoofdbeeld.src = v.beeld;
        hoofdbeeld.removeAttribute('srcset');
      }

      /* Aankondigen wat er veranderd is. Zonder dit hoort een schermlezer
         niets bij het kiezen van een kleur: prijs, voorraad en knop wisselen
         allemaal stil. */
      var melding = pdp.querySelector('[data-aj-melding]');
      if (melding) {
        melding.textContent = v.titel + ', ' + v.prijs_tekst + ', ' +
          (v.beschikbaar ? 'op voorraad' : 'tijdelijk uitverkocht');
      }

      try {
        var url = new URL(window.location);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      } catch (e) { /* oudere browser, geen ramp */ }

      AJ.zetVariant(v);
    }

    /* Het volle knoplabel onthouden voordat "Tijdelijk uitverkocht" het
       overschrijft, anders komt het na het wisselen van kleur nooit terug. */
    [hoofdknop, balkknop].forEach(function (knop) {
      if (!knop) return;
      var label = knop.querySelector('[data-aj-knoplabel]');
      var tekst = label ? label.textContent.trim() : '';
      if (tekst && tekst !== 'Tijdelijk uitverkocht') knop.setAttribute('data-aj-vol', tekst);
    });

    pdp.addEventListener('change', function (e) {
      if (e.target.matches('[data-aj-optie]')) teken(zoekVariant(gekozenOpties()));
    });

    /* De galerij: een klik op een thumbnail wisselt het hoofdbeeld. */
    pdp.addEventListener('click', function (e) {
      var duim = e.target.closest('[data-aj-duim]');
      if (!duim || !hoofdbeeld) return;
      hoofdbeeld.src = duim.getAttribute('data-aj-duim');
      hoofdbeeld.removeAttribute('srcset');
      hoofdbeeld.alt = duim.getAttribute('data-aj-duim-alt') || hoofdbeeld.alt;
      pdp.querySelectorAll('[data-aj-duim]').forEach(function (d) { d.classList.toggle('is-aan', d === duim); });
    });

    /* De koppeling van de koopknop staat bovenaan deze functie, voor de afslag
       op varianten. Zie de uitleg daar. */
  }

  /* ------------------------------------------------------------------ */
  /* 5. Stalenwaaier                                                     */
  /* ------------------------------------------------------------------ */

  /* De waaier is GEEN tweede variantkiezer. Klikken op een staal zet de
     bijbehorende radioknop in aj-varianten aan en laat die het werk doen:
     prijs, galerij, koopknop en koopbalk hangen daar al aan. Twee plekken die
     allebei denken dat ze de waarheid over de gekozen variant hebben, is
     precies de bug die je pas op een telefoon ziet. */
  function stalenStart(blok) {
    var stalen = Array.prototype.slice.call(blok.querySelectorAll('[data-aj-staal]'));
    var panelen = Array.prototype.slice.call(blok.querySelectorAll('[data-aj-paneel]'));
    if (!stalen.length) return;

    function toon(nr) {
      stalen.forEach(function (s) {
        var aan = s.getAttribute('data-aj-staal') === nr;
        s.classList.toggle('is-aan', aan);
        s.setAttribute('aria-selected', aan ? 'true' : 'false');
      });
      panelen.forEach(function (pa) {
        pa.hidden = pa.getAttribute('data-aj-paneel') !== nr;
      });
    }

    function kies(waarde) {
      /* De radioknop met deze waarde aanzetten en het change-event vuren, zodat
         pdpStart hem oppikt alsof de klant hem zelf aanklikte. */
      var radio = null;
      document.querySelectorAll('[data-aj-optie]').forEach(function (r) {
        if (!radio && r.value === waarde) radio = r;
      });
      if (!radio) return false;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    blok.addEventListener('click', function (e) {
      var staal = e.target.closest('[data-aj-staal]');
      if (staal) {
        toon(staal.getAttribute('data-aj-staal'));
        kies(staal.getAttribute('data-aj-waarde'));
        return;
      }
      var knop = e.target.closest('[data-aj-kies]');
      if (knop) {
        kies(knop.getAttribute('data-aj-kies'));
        /* Na "Kies deze" naar het koopblok, want dat is waar de klant heen wil
           en op mobiel staat dat ver naar boven. */
        var koop = document.querySelector('[data-aj-hoofdknop]');
        if (koop) koop.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    /* Pijltoetsen tussen de stalen, zoals bij een echte tablist. */
    blok.addEventListener('keydown', function (e) {
      var i = stalen.indexOf(document.activeElement);
      if (i < 0) return;
      var volgende = null;
      if (e.key === 'ArrowRight') volgende = stalen[(i + 1) % stalen.length];
      if (e.key === 'ArrowLeft') volgende = stalen[(i - 1 + stalen.length) % stalen.length];
      if (e.key === 'Home') volgende = stalen[0];
      if (e.key === 'End') volgende = stalen[stalen.length - 1];
      if (!volgende) return;
      e.preventDefault();
      volgende.focus();
      toon(volgende.getAttribute('data-aj-staal'));
      kies(volgende.getAttribute('data-aj-waarde'));
    });

    /* De rij moet weten hoeveel stalen er zijn, want de breedte van de waaier
       hangt ervan af. In Liquid is dat aantal pas na de lus bekend. */
    var rij = blok.querySelector('.aj-st__rij');
    if (rij) rij.style.setProperty('--aj-st-n', stalen.length);

    /* Kiest de klant elders een kleur, dan schuift de waaier mee. */
    document.addEventListener('aj:variant', function (e) {
      var v = e.detail;
      if (!v || !v.opties) return;
      stalen.forEach(function (s) {
        if (v.opties.indexOf(s.getAttribute('data-aj-waarde')) !== -1) {
          toon(s.getAttribute('data-aj-staal'));
        }
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* 6. Mobiele koopbalk                                                 */
  /* ------------------------------------------------------------------ */

  function koopbalkStart(balk) {
    var anker = document.querySelector(balk.getAttribute('data-aj-koopbalk') || '[data-aj-hoofdknop]');
    if (!anker || !('IntersectionObserver' in window)) return;

    var kijker = new IntersectionObserver(function (rijen) {
      rijen.forEach(function (r) {
        balk.toggleAttribute('data-aan', !r.isIntersecting);
      });
    }, { rootMargin: '0px 0px -20px 0px' });

    kijker.observe(anker);
  }

  /* ------------------------------------------------------------------ */

  function start(wortel) {
    wortel = wortel || document;
    wortel.querySelectorAll('[data-aj-bundel]').forEach(bundelStart);
    wortel.querySelectorAll('[data-aj-sorteer]').forEach(sorteerStart);
    wortel.querySelectorAll('[role="tablist"]').forEach(tabsStart);
    wortel.querySelectorAll('[data-aj-koopbalk]').forEach(koopbalkStart);
    wortel.querySelectorAll('[data-aj-pdp]').forEach(pdpStart);
    wortel.querySelectorAll('[data-aj-stalen]').forEach(stalenStart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else {
    start();
  }

  /* De theme-editor bouwt een sectie opnieuw op zonder de pagina te herladen.
     Zonder deze twee luisteraars is elke sectie na een instelling dood in de
     editor, en dat kost een uur zoeken naar een bug die er niet is. */
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
  document.addEventListener('shopify:block:select', function (e) { start(e.target); });

  AJ.start = start;
  window.AJ = AJ;
})();
